import request from '@/utils/request.js'
const proxyGetway = 'proxy-gateway/gw-core/'
export function itemAddBatch(data) {
  return request({
    url: proxyGetway + 'product-batch/create',
    method: 'post',
    data
  })
}
export function itemGetBatchBySKU(data) {
  return request({
    url: proxyGetway + 'product-batch/search',
    method: 'post',
    data
  })
}